import { AlertTriangle } from 'lucide-react';
import { CheckoutShell } from './CheckoutShell.jsx';

export function CheckoutNotFound({ message }) {
  return (
    <CheckoutShell merchant={null} payment={null} showTrust={false}>
      <div className="py-6 text-center lg:py-0 lg:text-left">
        <div className="mx-auto mb-4 grid h-11 w-11 place-items-center rounded-xl border border-line bg-surface lg:mx-0">
          <AlertTriangle className="h-5 w-5 text-faint" aria-hidden="true" />
        </div>
        <h1 className="text-lg font-semibold tracking-tight text-ink">This checkout link isn&rsquo;t valid</h1>
        <p className="mt-2 text-sm leading-relaxed text-muted">
          {message ??
            'The link may be mistyped or have been cancelled. Ask the merchant for a new one — nothing has been charged.'}
        </p>
      </div>
    </CheckoutShell>
  );
}

export default CheckoutNotFound;
